(function landingtabContent($, Drupal) {
  Drupal.behaviors.landingtabContent = {
    attach(context) {
      const tab = $('.landing-tab__link', context);
      const pages = document.getElementsByClassName('landing-tab__content');

      tab.click((e) => {
        // Prevent default event and blur focus from tab.
        e.preventDefault();
        $(e.target).blur();

        const pageID = $(e.target).attr('href').replace('#', '');
        let siblingPage;

        // Loop over all the tabbed-content pages on the page.
        // Remove active classes and define the sibling page that matches our clicked tab.
        for (let i = 0; i < pages.length; i++) {
          $(pages[i]).removeClass('landing-tab__content--active');

          if ($(pages[i]).attr('id') === pageID) {
            siblingPage = $(pages[i]);
          }
        }
        // Remove any active tab classes.
        // We have a match, so simulate a click event to trigger the code later in this file.
        tab.removeClass('landing-tab__link--active');

        // Assign active classes to current tab and sibling page.
        // We have a match, so simulate a click event to trigger the code later in this file.
        $(e.target).addClass('landing-tab__link--active');

        // Set window hash without redirecting (causing a jump). Thanks History API!
        history.pushState(null, null, `#${pageID}`);

        siblingPage.addClass('landing-tab__content--active');
      });

      // Check window hash and open correct tab
      const pageHash = window.location.hash;
      // Check if we actually got anything from the page hash.
      if (pageHash) {
        // If we did, collect the tabs into an array.
        // We have a match, so simulate a click event to trigger the code later in this file.
        const tabs = document.getElementsByClassName('landing-tab__link');

        // Loop over the tabs and find one that matches our page hash
        for (let i = 0; i < tabs.length; i++) {
          if (pageHash === tabs[i].getAttribute('href')) {
            // We have a match, so simulate a click event to trigger the code later in this file.
            // It's inelegant, but we aren't loading content dynamically so its our best option.
            tabs[i].click();
          }
        }
      }
      // Custom Search Bar
      const searchInput = $('.input-search--secondary', context).find('input[type=search]');
      const search = $('.input-search__button--secondary', context);
      let searchValue;

      search.click((e) => {
        e.preventDefault();
        // If user does not enter value in search input, define default search value.
        if (searchInput.val() === '') {
          searchValue = '';
        }
        else {
          searchValue = searchInput.val();
        }

        // Determine the search page using the input id and value.
        window.location.href = `/${searchInput.attr('id')}/?title=${searchValue}`;
      });
    },
  };
}(jQuery, Drupal));
